import { render } from "./MotmHome.vue?vue&type=template&id=ff8bff2c&scoped=true"
import script from "./MotmHome.vue?vue&type=script&lang=js"
export * from "./MotmHome.vue?vue&type=script&lang=js"

import "./MotmHome.vue?vue&type=style&index=0&id=ff8bff2c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8bff2c"]])

export default __exports__